// src/routes/hotelRatingsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import HotelRatings from '../pages/hotelRatings/HotelRatings';
import CreateHotelRating from '../pages/hotelRatings/CreateHotelRating';
import EditHotelRating from '../pages/hotelRatings/EditHotelRating';
import ProtectedRoute from '../components/global/ProtectedRoute';

const hotelRatingsRoutes = (
    <>
        {/* Hotel Ratings List */}
        <Route
            path="/hotel-ratings"
            element={
                <ProtectedRoute requiredPermission="hotel_ratings_list">
                    <HotelRatings />
                </ProtectedRoute>
            }
        />

        {/* Hotel Ratings Archive */}
        <Route
            path="/hotel-ratings/archive"
            element={
                <ProtectedRoute requiredPermission="hotel_ratings_archive_list">
                    <HotelRatings />
                </ProtectedRoute>
            }
        />

        {/* Create Hotel Rating */}
        <Route
            path="/hotel-ratings/create"
            element={
                <ProtectedRoute requiredPermission="hotel_ratings_create">
                    <CreateHotelRating />
                </ProtectedRoute>
            }
        />

        {/* Edit Hotel Rating */}
        <Route
            path="/hotel-ratings/:id/edit"
            element={
                <ProtectedRoute requiredPermission="hotel_ratings_edit">
                    <EditHotelRating />
                </ProtectedRoute>
            }
        />
    </>
);

export default hotelRatingsRoutes;
